import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white recent-activity-box" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-sm-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "list ps-0 mb-0 list-unstyled" }
const _hoisted_4 = { class: "text-black fw-bold" }
const _hoisted_5 = { class: "d-block fs-13 mt-1" }
const _hoisted_6 = { class: "pagination" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { key: 1 }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { key: 2 }
const _hoisted_11 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[6] || (_cache[6] = _createElementVNode("div", { class: "mb-15 mb-md-20 mb-xxxl-25 d-flex align-itemsh5s-center justify-content-between" }, [
        _createElementVNode("h5", { class: "card-title fw-bold mb-0" }, "Recent Activity")
      ], -1)),
      _createElementVNode("ul", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rows, (item) => {
          return (_openBlock(), _createElementBlock("li", {
            class: "position-relative fw-medium text-dark-emphasis",
            key: item.id
          }, [
            _cache[4] || (_cache[4] = _createElementVNode("div", { class: "icon position-absolute start-0 rounded-circle text-center" }, [
              _createElementVNode("i", { class: "ph-duotone ph-check-circle" })
            ], -1)),
            _createElementVNode("span", _hoisted_4, _toDisplayString(item.task_type), 1),
            _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1)),
            _createTextVNode(" " + _toDisplayString(item.task) + " ", 1),
            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.getDate(item.created_at)), 1)
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("button", {
        disabled: _ctx.filter.current_page === 1,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changePage(_ctx.filter.current_page - 1)))
      }, " Prev ", 8, _hoisted_7),
      (_ctx.startPage > 1)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changePage(1)))
          }, "1"))
        : _createCommentVNode("", true),
      (_ctx.startPage > 2)
        ? (_openBlock(), _createElementBlock("span", _hoisted_8, "..."))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pagesToShow, (page) => {
        return (_openBlock(), _createElementBlock("button", {
          key: page,
          class: _normalizeClass({ active: page === _ctx.filter.current_page }),
          onClick: ($event: any) => (_ctx.changePage(page))
        }, _toDisplayString(page), 11, _hoisted_9))
      }), 128)),
      (_ctx.endPage < _ctx.totalPages)
        ? (_openBlock(), _createElementBlock("span", _hoisted_10, "..."))
        : _createCommentVNode("", true),
      (_ctx.endPage < _ctx.totalPages)
        ? (_openBlock(), _createElementBlock("button", {
            key: 3,
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changePage(_ctx.totalPages)))
          }, _toDisplayString(_ctx.totalPages), 1))
        : _createCommentVNode("", true),
      _createElementVNode("button", {
        disabled: _ctx.filter.current_page === _ctx.totalPages,
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.changePage(_ctx.filter.current_page + 1)))
      }, " Next ", 8, _hoisted_11)
    ])
  ]))
}